import React, { FunctionComponent } from 'react';
import IResponse from '../../Models/IResponse';
import IRefiners from '../../Models/IRefiners';
import { getFilterParametersFromUrl } from '../../utils/urlParamHelper';
import { Log } from '../../utils/logging';


export interface ISuggestionBoxProps {
    query?: string;
    searchboxQuery?: string;
    erronousQuery?: string;
    querySuggestion?: string;
    emptyFilters: () => void;
    initialFilters?: IRefiners[];
    refinementFilters?: string[];
    searchWithoutFiltersHasResults?: boolean;
    isSearchingWithDeactivatedFilters?: boolean;
    results?: IResponse;
    predefinedFilterLabel?: string;
    isInitialSearch?: boolean;
}



export const SuggestionBox: FunctionComponent<ISuggestionBoxProps> =
    ({ query, searchboxQuery, erronousQuery, querySuggestion, emptyFilters, initialFilters, refinementFilters, searchWithoutFiltersHasResults, isSearchingWithDeactivatedFilters, results, predefinedFilterLabel, isInitialSearch }) => {
        const displaySearchWithoutFilterGiveResults = searchWithoutFiltersHasResults;

        if(results?.totalResults === 0 && results?.totalResultsIncludingDuplicates === 0) {
            // Still show the "uten filtervalg" message even when 0 results
            if (!displaySearchWithoutFilterGiveResults) {
                return null;
            }
        }
        
        if (displaySearchWithoutFilterGiveResults) {
            // When only predefined filters were active, show simpler message without "0 treff med filtre"
            if (predefinedFilterLabel) {
                return (
                    <div className="emptyResultBanner">
                        {querySuggestion && erronousQuery && (
                            <><span>Søket etter </span><span className="uthevet">"{erronousQuery}"</span><span> ga 0 treff. </span></>
                        )}
                        <span>Viser resultater for </span>
                        <span className="uthevet">"{query}"</span>
                        <span> uten filtervalg.</span>
                    </div>
                );
            }
            let activeFilters = joinChildren(initialFilters);
            if(refinementFilters !== undefined && activeFilters.length === 0){
                let urlFilters = getFilterParametersFromUrl(refinementFilters);
                activeFilters = joinChildren(urlFilters);
            }
            const gyldighet = new URLSearchParams(window.location.search).get('gyldighet');
            // Only treat as "predefined filter only" if gyldighet is set AND no other filters are active
            const urlParams = new URLSearchParams(window.location.search);
            const hasOtherFilters = refinementFilters ? refinementFilters.some(f => f !== 'gyldighet' && urlParams.get(f)) : false;
            const hasOnlyPredefinedFilter = predefinedFilterLabel && gyldighet && gyldighet.includes('Gyldig innhold') && !hasOtherFilters;
            
            return (
                <div className="emptyResultBanner">
                    <span>Søket ga 0 treff for </span>
                    <span className="uthevet">"{searchboxQuery}"</span>
                    {hasOnlyPredefinedFilter
                        ? <span> innen {predefinedFilterLabel}.</span>
                        : <span> med valgte filtre.</span>
                    }
                    {/* 
                    <span className="uthevet lowercase">
                        {activeFilters}.
                    </span>
                    */}
                    <p></p>
                    <span>Viser resultater for </span>
                    <span className="uthevet">"{query}"</span>
                    {hasOnlyPredefinedFilter
                        ? <span> innen alt innhold.</span>
                        : <span> uten filtervalg.</span>
                    }
                    {/*
                    <span className="uthevet">
                        <button onClick={emptyFilters}>{query}</button>
                    </span>
                    <span> uten filtervalg.</span>
                    */}
                </div>
            );
        }
        const displaySuggestionBox = querySuggestion && querySuggestion.length > 0;
        if (displaySuggestionBox) {
            return (
                <div className="emptyResultBanner">
                    <span>Søket etter </span>
                    <span className="uthevet">"{erronousQuery}"</span>
                    <span> ga 0 treff. Viser resultater for </span>
                    <span className="uthevet">"{querySuggestion}"</span>
                    <span>.</span>
                </div>
            );
        }
        const displayInactiveFilterBox = isSearchingWithDeactivatedFilters;
        if (displayInactiveFilterBox) {
            if (initialFilters && initialFilters.length > 0) {
                let filtervalgText = initialFilters.length === 1 ? "filtervalget" : 'filtervalgene';
                return (<div className="emptyResultBanner">
                    <span>Søke ga 0 treff for </span>
                    <span className="uthevet">
                        "{query}"
                    </span>
                    <span> med {filtervalgText} </span>
                    <span className="uthevet">
                        {joinChildren(initialFilters)}.
                    </span>
                    <p></p>
                    <span>Viser resultater for </span>
                    <span className="uthevet">{query}, inkludert utgåtte versjoner.</span>
                </div>
                );
            } else {
                return (<div className="emptyResultBanner">
                    <span>Søket ga 0 treff for </span>
                    <span className="uthevet">
                        "{query}"
                    </span>
                    <span>. Viser resultater for </span>
                    <span className="uthevet">{query}, inkludert utgåtte versjoner.</span>
                </div>
                );
            }
        }
        const queryModifiedByQueryRule = (results && results.modifiedQuery && results.modifiedQuery.length > 0) ? true : false;
        if (queryModifiedByQueryRule) {
            if (results && results.modifiedQuery && results.modifiedQuery.length > 0) {
                return (
                    <div className="emptyResultBanner">
                        <span>Søket ga 0 treff for </span>
                        <span className="uthevet">"{query}"</span>
                        <span>. Viser resultater for </span>
                        <span className="uthevet">{results.modifiedQuery}.</span>
                    </div>
                );
            }
        }
        return null;
    }


function renderSeparator() {
    return ', '
}

function renderHighlightedSpan(text, index) {
    return <span key={`filterError-${index}`} className="highlighted">{text}</span>;
}

function joinChildren(filters) {
    let children: any[] = [];
    Log(filters);
    if(filters !== undefined){
        filters.forEach(refinementFilter => {
            refinementFilter.Entries.forEach(entry => {
                children.push(entry.RefinementValue);
            });
        });
    }
    return children.reduce((result, child, index) => {
        if (index < children.length - 1) {
            return result.concat([renderHighlightedSpan(child, index), renderSeparator()])
        }

        return result.concat(renderHighlightedSpan(child, index))
    }, [])
}
